import { BaseMutationTypes } from '../BaseMutationTypes';

export class UserMutationTypes extends BaseMutationTypes {
  public static readonly Loading = 'LOADING';
  public static readonly CurrentUserAuthenticated = 'CURRENT_USER_AUTHENTICATED';
  public static readonly CurrentUserLoaded = 'CURRENT_USER_LOADED';
  public static readonly CurrentUserError = 'CURRENT_USER_ERROR';
  public static readonly AppActivityWhileSignedIn = 'APP_ACTIVITY_WHILE_SIGNED_IN';
  public static readonly PreviousRoute = 'PREVIOUS_ROUTE';
  public static readonly ErrorPageRoute = 'ERROR_PAGE_ROUTE';
}
